<template>
  <v-menu
    offset-y
  >
    <template #activator="{ on, attrs }">
      <slot
        :on="on"
        :attrs="attrs"
        :loading="loading"
        name="activator"
      />
    </template>

    <v-list>
      <v-subheader>{{ $t('Available languages') }}</v-subheader>
      <v-list-item
        v-for="language in languages"
        :key="language.code"
        color="primary"
        :disabled="language.code === $page.props.app_locales.current.code"
        :input-value="language.code === $page.props.app_locales.current.code"
        @click="changeAppLocale(language)"
      >
        <v-list-item-title>{{ language.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import sortBy from 'lodash/sortBy';

export default {
  data() {
    return {
      loading: false,
    }
  },

  computed: {
    languages() {
      const languages = this.$page.props.app_locales.available;
      return sortBy(Object.values(languages), ['name']);
    }
  },

  methods: {
    changeAppLocale(language) {
      this.loading = true;

      const url = this.route('app-locale.update', {
        locale: language.code,
      });

      this.$inertia.patch(url, {}, {
        preserveState: true,
        preserveScroll: true,
        onSuccess: () => {
          this.$i18n.locale = this.$page.props.app_locales.current.code;
          this.loading = false;
        }
      });
    }
  }
}
</script>